module.exports = __webpack_public_path__ + "static/img/index-pro-前策.983b08e4.png";